/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userUsedCoupons.internal

import features.userUsedCoupons.models.UserCouponsModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.userUsedCoupons.internal.UserUsedCouponsUseCase.Params

internal class UserUsedCouponsUseCase : AsyncUseCase<UserCouponsModel, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,

    )

    private val userUsedCouponsService: UserUsedCouponsService = UserUsedCouponsServiceImpl()

    override suspend fun run(params: Params): Result<UserCouponsModel> {
        return userUsedCouponsService.getUserUsedCoupons(
            overrideHeaders = params.overrideHeaders,

        )
    }
}
